// Country and Currency Configuration
export const countries = [
  {
    code: 'IN',
    name: 'India',
    nameNative: 'भारत',
    currency: 'INR',
    currencySymbol: '₹',
    languages: ['ur', 'hi', 'ml', 'en'],
    flag: '🇮🇳',
    defaultLanguage: 'ur'
  },
  {
    code: 'AE',
    name: 'UAE',
    nameNative: 'الإمارات',
    currency: 'AED',
    currencySymbol: 'د.إ',
    languages: ['en', 'ar'],
    flag: '🇦🇪',
    defaultLanguage: 'ar'
  },
  {
    code: 'SA',
    name: 'Saudi Arabia',
    nameNative: 'السعودية',
    currency: 'SAR',
    currencySymbol: '﷼',
    languages: ['en', 'ar'],
    flag: '🇸🇦',
    defaultLanguage: 'ar'
  },
  {
    code: 'PK',
    name: 'Pakistan',
    nameNative: 'پاکستان',
    currency: 'PKR',
    currencySymbol: 'Rs',
    languages: ['en', 'ur'],
    flag: '🇵🇰',
    defaultLanguage: 'ur'
  },
  {
    code: 'GB',
    name: 'United Kingdom',
    nameNative: 'United Kingdom',
    currency: 'GBP',
    currencySymbol: '£',
    languages: ['en'],
    flag: '🇬🇧',
    defaultLanguage: 'en'
  },
  {
    code: 'US',
    name: 'United States',
    nameNative: 'United States',
    currency: 'USD',
    currencySymbol: '$',
    languages: ['en'],
    flag: '🇺🇸',
    defaultLanguage: 'en'
  },
  {
    code: 'MY',
    name: 'Malaysia',
    nameNative: 'Malaysia',
    currency: 'MYR',
    currencySymbol: 'RM',
    languages: ['en', 'ms'],
    flag: '🇲🇾',
    defaultLanguage: 'ms'
  },
  {
    code: 'FR',
    name: 'France',
    nameNative: 'France',
    currency: 'EUR',
    currencySymbol: '€',
    languages: ['en', 'fr'],
    flag: '🇫🇷',
    defaultLanguage: 'fr'
  },
  {
    code: 'ID',
    name: 'Indonesia',
    nameNative: 'Indonesia',
    currency: 'IDR',
    currencySymbol: 'Rp',
    languages: ['id', 'en', 'ms'],
    flag: '🇮🇩',
    defaultLanguage: 'id'
  },
  {
    code: 'BD',
    name: 'Bangladesh',
    nameNative: 'বাংলাদেশ',
    currency: 'BDT',
    currencySymbol: '৳',
    languages: ['bn', 'en'],
    flag: '🇧🇩',
    defaultLanguage: 'bn'
  },
  {
    code: 'TR',
    name: 'Turkey',
    nameNative: 'Türkiye',
    currency: 'TRY',
    currencySymbol: '₺',
    languages: ['tr', 'en'],
    flag: '🇹🇷',
    defaultLanguage: 'tr'
  },
  {
    code: 'RU',
    name: 'Russia',
    nameNative: 'Россия',
    currency: 'RUB',
    currencySymbol: '₽',
    languages: ['ru', 'en'],
    flag: '🇷🇺',
    defaultLanguage: 'ru'
  },
  {
    code: 'KZ',
    name: 'Kazakhstan',
    nameNative: 'Қазақстан',
    currency: 'KZT',
    currencySymbol: '₸',
    languages: ['ru', 'en'],
    flag: '🇰🇿',
    defaultLanguage: 'ru'
  },
  {
    code: 'UZ',
    name: 'Uzbekistan',
    nameNative: 'Oʻzbekiston',
    currency: 'UZS',
    currencySymbol: 'soʻm',
    languages: ['ru', 'en'],
    flag: '🇺🇿',
    defaultLanguage: 'ru'
  },
  {
    code: 'KG',
    name: 'Kyrgyzstan',
    nameNative: 'Кыргызстан',
    currency: 'KGS',
    currencySymbol: 'с',
    languages: ['ru', 'en'],
    flag: '🇰🇬',
    defaultLanguage: 'ru'
  },
  {
    code: 'TJ',
    name: 'Tajikistan',
    nameNative: 'Тоҷикистон',
    currency: 'TJS',
    currencySymbol: 'смн',
    languages: ['ru', 'en'],
    flag: '🇹🇯',
    defaultLanguage: 'ru'
  },
  {
    code: 'AZ',
    name: 'Azerbaijan',
    nameNative: 'Azərbaycan',
    currency: 'AZN',
    currencySymbol: '₼',
    languages: ['tr', 'ru', 'en'],
    flag: '🇦🇿',
    defaultLanguage: 'tr'
  },
  {
    code: 'TM',
    name: 'Turkmenistan',
    nameNative: 'Türkmenistan',
    currency: 'TMT',
    currencySymbol: 'm',
    languages: ['tr', 'ru', 'en'],
    flag: '🇹🇲',
    defaultLanguage: 'tr'
  },
  {
    code: 'CY',
    name: 'Northern Cyprus',
    nameNative: 'Kuzey Kıbrıs',
    currency: 'TRY',
    currencySymbol: '₺',
    languages: ['tr', 'en'],
    flag: '🇹🇷',
    defaultLanguage: 'tr'
  },
  // ---------- Arabic-script countries ----------
  { code: 'EG', name: 'Egypt',            nameNative: 'مصر',           currency: 'EGP', currencySymbol: 'ج.م', languages: ['ar', 'en'], flag: '🇪🇬', defaultLanguage: 'ar' },
  { code: 'MA', name: 'Morocco',          nameNative: 'المغرب',        currency: 'MAD', currencySymbol: 'د.م.', languages: ['ar', 'fr', 'en'], flag: '🇲🇦', defaultLanguage: 'ar' },
  { code: 'DZ', name: 'Algeria',          nameNative: 'الجزائر',       currency: 'DZD', currencySymbol: 'د.ج', languages: ['ar', 'fr', 'en'], flag: '🇩🇿', defaultLanguage: 'ar' },
  { code: 'TN', name: 'Tunisia',          nameNative: 'تونس',          currency: 'TND', currencySymbol: 'د.ت', languages: ['ar', 'fr', 'en'], flag: '🇹🇳', defaultLanguage: 'ar' },
  { code: 'LY', name: 'Libya',            nameNative: 'ليبيا',         currency: 'LYD', currencySymbol: 'ل.د', languages: ['ar', 'en'], flag: '🇱🇾', defaultLanguage: 'ar' },
  { code: 'SD', name: 'Sudan',            nameNative: 'السودان',        currency: 'SDG', currencySymbol: 'ج.س', languages: ['ar', 'en'], flag: '🇸🇩', defaultLanguage: 'ar' },
  { code: 'IQ', name: 'Iraq',             nameNative: 'العراق',         currency: 'IQD', currencySymbol: 'ع.د', languages: ['ar', 'en'], flag: '🇮🇶', defaultLanguage: 'ar' },
  { code: 'JO', name: 'Jordan',           nameNative: 'الأردن',        currency: 'JOD', currencySymbol: 'د.أ', languages: ['ar', 'en'], flag: '🇯🇴', defaultLanguage: 'ar' },
  { code: 'LB', name: 'Lebanon',          nameNative: 'لبنان',         currency: 'LBP', currencySymbol: 'ل.ل', languages: ['ar', 'fr', 'en'], flag: '🇱🇧', defaultLanguage: 'ar' },
  { code: 'SY', name: 'Syria',            nameNative: 'سوريا',         currency: 'SYP', currencySymbol: 'ل.س', languages: ['ar', 'en'], flag: '🇸🇾', defaultLanguage: 'ar' },
  { code: 'PS', name: 'Palestine',        nameNative: 'فلسطين',        currency: 'ILS', currencySymbol: '₪', languages: ['ar', 'en'], flag: '🇵🇸', defaultLanguage: 'ar' },
  { code: 'YE', name: 'Yemen',            nameNative: 'اليمن',          currency: 'YER', currencySymbol: '﷼', languages: ['ar', 'en'], flag: '🇾🇪', defaultLanguage: 'ar' },
  { code: 'KW', name: 'Kuwait',           nameNative: 'الكويت',         currency: 'KWD', currencySymbol: 'د.ك', languages: ['ar', 'en'], flag: '🇰🇼', defaultLanguage: 'ar' },
  { code: 'QA', name: 'Qatar',            nameNative: 'قطر',            currency: 'QAR', currencySymbol: 'ر.ق', languages: ['ar', 'en'], flag: '🇶🇦', defaultLanguage: 'ar' },
  { code: 'BH', name: 'Bahrain',          nameNative: 'البحرين',        currency: 'BHD', currencySymbol: 'د.ب', languages: ['ar', 'en'], flag: '🇧🇭', defaultLanguage: 'ar' },
  { code: 'OM', name: 'Oman',             nameNative: 'عُمان',          currency: 'OMR', currencySymbol: 'ر.ع.', languages: ['ar', 'en'], flag: '🇴🇲', defaultLanguage: 'ar' },
  { code: 'MR', name: 'Mauritania',       nameNative: 'موريتانيا',     currency: 'MRU', currencySymbol: 'UM', languages: ['ar', 'fr', 'en'], flag: '🇲🇷', defaultLanguage: 'ar' },
  // ---------- Francophone (Latin script, French is co-official) ----------
  { code: 'SN', name: 'Senegal',          nameNative: 'Sénégal',        currency: 'XOF', currencySymbol: 'CFA', languages: ['fr', 'ar', 'en'], flag: '🇸🇳', defaultLanguage: 'fr' },
  { code: 'ML', name: 'Mali',             nameNative: 'Mali',           currency: 'XOF', currencySymbol: 'CFA', languages: ['fr', 'ar', 'en'], flag: '🇲🇱', defaultLanguage: 'fr' },
  { code: 'NE', name: 'Niger',            nameNative: 'Niger',          currency: 'XOF', currencySymbol: 'CFA', languages: ['fr', 'ar', 'en'], flag: '🇳🇪', defaultLanguage: 'fr' },
  { code: 'BF', name: 'Burkina Faso',     nameNative: 'Burkina Faso',   currency: 'XOF', currencySymbol: 'CFA', languages: ['fr', 'ar', 'en'], flag: '🇧🇫', defaultLanguage: 'fr' },
  { code: 'CI', name: "Côte d'Ivoire",    nameNative: "Côte d'Ivoire",  currency: 'XOF', currencySymbol: 'CFA', languages: ['fr', 'en'], flag: '🇨🇮', defaultLanguage: 'fr' },
  { code: 'TD', name: 'Chad',             nameNative: 'Tchad',          currency: 'XAF', currencySymbol: 'FCFA', languages: ['fr', 'ar', 'en'], flag: '🇹🇩', defaultLanguage: 'fr' },
  { code: 'CM', name: 'Cameroon',         nameNative: 'Cameroun',       currency: 'XAF', currencySymbol: 'FCFA', languages: ['fr', 'en'], flag: '🇨🇲', defaultLanguage: 'fr' },
  { code: 'GN', name: 'Guinea',           nameNative: 'Guinée',         currency: 'GNF', currencySymbol: 'FG', languages: ['fr', 'ar', 'en'], flag: '🇬🇳', defaultLanguage: 'fr' },
  { code: 'BJ', name: 'Benin',            nameNative: 'Bénin',          currency: 'XOF', currencySymbol: 'CFA', languages: ['fr', 'en'], flag: '🇧🇯', defaultLanguage: 'fr' },
  { code: 'KM', name: 'Comoros',          nameNative: 'جزر القمر / Comores', currency: 'KMF', currencySymbol: 'CF', languages: ['ar', 'fr', 'en'], flag: '🇰🇲', defaultLanguage: 'ar' },
  { code: 'DJ', name: 'Djibouti',         nameNative: 'جيبوتي / Djibouti',   currency: 'DJF', currencySymbol: 'Fdj', languages: ['ar', 'fr', 'en'], flag: '🇩🇯', defaultLanguage: 'ar' },
  { code: 'CA', name: 'Canada',           nameNative: 'Canada',         currency: 'CAD', currencySymbol: 'C$', languages: ['en', 'fr'], flag: '🇨🇦', defaultLanguage: 'en' },
  { code: 'BE', name: 'Belgium',          nameNative: 'Belgique',       currency: 'EUR', currencySymbol: '€',  languages: ['fr', 'en'], flag: '🇧🇪', defaultLanguage: 'fr' },
  // ---------- Feb 2026 — Nigeria + Iran + Afghanistan + Brunei ----------
  { code: 'NG', name: 'Nigeria',          nameNative: 'Nigeria',        currency: 'NGN', currencySymbol: '₦',  languages: ['en', 'ar'], flag: '🇳🇬', defaultLanguage: 'en' },
  { code: 'IR', name: 'Iran',             nameNative: 'ایران',          currency: 'IRR', currencySymbol: '﷼',  languages: ['fa', 'ar', 'en'], flag: '🇮🇷', defaultLanguage: 'fa' },
  { code: 'AF', name: 'Afghanistan',      nameNative: 'افغانستان',      currency: 'AFN', currencySymbol: '؋',  languages: ['fa', 'ar', 'ur', 'en'], flag: '🇦🇫', defaultLanguage: 'fa' },
  { code: 'BN', name: 'Brunei',           nameNative: 'Brunei Darussalam', currency: 'BND', currencySymbol: 'B$', languages: ['ms', 'en'], flag: '🇧🇳', defaultLanguage: 'ms' },
  // ---------- Feb 2026 — East Africa + Sri Lanka + Philippines + China ----------
  { code: 'KE', name: 'Kenya',            nameNative: 'Kenya',          currency: 'KES', currencySymbol: 'KSh', languages: ['en', 'ar'], flag: '🇰🇪', defaultLanguage: 'en' },
  { code: 'TZ', name: 'Tanzania',         nameNative: 'Tanzania',       currency: 'TZS', currencySymbol: 'TSh', languages: ['en', 'ar'], flag: '🇹🇿', defaultLanguage: 'en' },
  { code: 'UG', name: 'Uganda',           nameNative: 'Uganda',         currency: 'UGX', currencySymbol: 'USh', languages: ['en', 'ar'], flag: '🇺🇬', defaultLanguage: 'en' },
  { code: 'ET', name: 'Ethiopia',         nameNative: 'ኢትዮጵያ',         currency: 'ETB', currencySymbol: 'Br',  languages: ['en', 'ar'], flag: '🇪🇹', defaultLanguage: 'en' },
  { code: 'SO', name: 'Somalia',          nameNative: 'Soomaaliya',     currency: 'SOS', currencySymbol: 'Sh.So.', languages: ['ar', 'en'], flag: '🇸🇴', defaultLanguage: 'ar' },
  { code: 'LK', name: 'Sri Lanka',        nameNative: 'ශ්‍රී ලංකා',       currency: 'LKR', currencySymbol: 'Rs', languages: ['en', 'ar', 'ml'], flag: '🇱🇰', defaultLanguage: 'en' },
  { code: 'PH', name: 'Philippines',      nameNative: 'Pilipinas',      currency: 'PHP', currencySymbol: '₱',  languages: ['en', 'ar'], flag: '🇵🇭', defaultLanguage: 'en' },
  { code: 'CN', name: 'China',            nameNative: '中国',            currency: 'CNY', currencySymbol: '¥',  languages: ['en', 'ar'], flag: '🇨🇳', defaultLanguage: 'en' },
  // ---------- Feb 2026 — Round 4: Southern Africa · SE Asia · Western Europe · Nordics · Maldives · Balkans ----------
  { code: 'ZA', name: 'South Africa',      nameNative: 'South Africa',    currency: 'ZAR', currencySymbol: 'R',   languages: ['en', 'ar'],       flag: '🇿🇦', defaultLanguage: 'en' },
  { code: 'TH', name: 'Thailand',          nameNative: 'ประเทศไทย',        currency: 'THB', currencySymbol: '฿',   languages: ['en', 'ms', 'ar'], flag: '🇹🇭', defaultLanguage: 'en' },
  { code: 'MM', name: 'Myanmar',           nameNative: 'မြန်မာ',           currency: 'MMK', currencySymbol: 'K',   languages: ['en', 'ar'],       flag: '🇲🇲', defaultLanguage: 'en' },
  { code: 'MV', name: 'Maldives',          nameNative: 'ދިވެހި',            currency: 'MVR', currencySymbol: 'Rf',  languages: ['en', 'ar'],       flag: '🇲🇻', defaultLanguage: 'en' },
  { code: 'DE', name: 'Germany',           nameNative: 'Deutschland',     currency: 'EUR', currencySymbol: '€',   languages: ['en', 'tr', 'ar'], flag: '🇩🇪', defaultLanguage: 'en' },
  { code: 'IT', name: 'Italy',             nameNative: 'Italia',          currency: 'EUR', currencySymbol: '€',   languages: ['en', 'ar'],       flag: '🇮🇹', defaultLanguage: 'en' },
  { code: 'ES', name: 'Spain',             nameNative: 'España',          currency: 'EUR', currencySymbol: '€',   languages: ['en', 'ar'],       flag: '🇪🇸', defaultLanguage: 'en' },
  { code: 'NL', name: 'Netherlands',       nameNative: 'Nederland',       currency: 'EUR', currencySymbol: '€',   languages: ['en', 'tr', 'ar'], flag: '🇳🇱', defaultLanguage: 'en' },
  { code: 'CH', name: 'Switzerland',       nameNative: 'Schweiz',         currency: 'CHF', currencySymbol: 'CHF', languages: ['en', 'fr', 'ar'], flag: '🇨🇭', defaultLanguage: 'en' },
  { code: 'AT', name: 'Austria',           nameNative: 'Österreich',      currency: 'EUR', currencySymbol: '€',   languages: ['en', 'tr', 'ar'], flag: '🇦🇹', defaultLanguage: 'en' },
  { code: 'SE', name: 'Sweden',            nameNative: 'Sverige',         currency: 'SEK', currencySymbol: 'kr',  languages: ['en', 'ar'],       flag: '🇸🇪', defaultLanguage: 'en' },
  { code: 'DK', name: 'Denmark',           nameNative: 'Danmark',         currency: 'DKK', currencySymbol: 'kr',  languages: ['en', 'ar'],       flag: '🇩🇰', defaultLanguage: 'en' },
  { code: 'NO', name: 'Norway',            nameNative: 'Norge',           currency: 'NOK', currencySymbol: 'kr',  languages: ['en', 'ar'],       flag: '🇳🇴', defaultLanguage: 'en' },
  // Balkans
  { code: 'AL', name: 'Albania',           nameNative: 'Shqipëria',       currency: 'ALL', currencySymbol: 'L',   languages: ['en', 'tr', 'ar'], flag: '🇦🇱', defaultLanguage: 'en' },
  { code: 'BA', name: 'Bosnia & Herzegovina', nameNative: 'Bosna i Hercegovina', currency: 'BAM', currencySymbol: 'KM', languages: ['en', 'tr', 'ar'], flag: '🇧🇦', defaultLanguage: 'en' },
  { code: 'XK', name: 'Kosovo',            nameNative: 'Kosova',          currency: 'EUR', currencySymbol: '€',   languages: ['en', 'tr', 'ar'], flag: '🇽🇰', defaultLanguage: 'en' },
  { code: 'MK', name: 'North Macedonia',   nameNative: 'Северна Македонија', currency: 'MKD', currencySymbol: 'ден', languages: ['en', 'tr', 'ar'], flag: '🇲🇰', defaultLanguage: 'en' },
  { code: 'ME', name: 'Montenegro',        nameNative: 'Crna Gora',       currency: 'EUR', currencySymbol: '€',   languages: ['en', 'ar'],       flag: '🇲🇪', defaultLanguage: 'en' },
  { code: 'RS', name: 'Serbia',            nameNative: 'Srbija',          currency: 'RSD', currencySymbol: 'дин', languages: ['en', 'ar'],       flag: '🇷🇸', defaultLanguage: 'en' },
  { code: 'HR', name: 'Croatia',           nameNative: 'Hrvatska',        currency: 'EUR', currencySymbol: '€',   languages: ['en', 'ar'],       flag: '🇭🇷', defaultLanguage: 'en' },
  { code: 'SI', name: 'Slovenia',          nameNative: 'Slovenija',       currency: 'EUR', currencySymbol: '€',   languages: ['en', 'ar'],       flag: '🇸🇮', defaultLanguage: 'en' },
  { code: 'BG', name: 'Bulgaria',          nameNative: 'България',        currency: 'BGN', currencySymbol: 'лв',  languages: ['en', 'tr', 'ar'], flag: '🇧🇬', defaultLanguage: 'en' },
  // ---------- Mar 2026 — Round 5: More Europe (tech + Muslim expat hubs) + Oceania + high-tech Asia + Brazil ----------
  { code: 'PL', name: 'Poland',            nameNative: 'Polska',           currency: 'PLN', currencySymbol: 'zł',  languages: ['en', 'ar'],       flag: '🇵🇱', defaultLanguage: 'en' },
  { code: 'PT', name: 'Portugal',          nameNative: 'Portugal',         currency: 'EUR', currencySymbol: '€',   languages: ['en', 'ar'],       flag: '🇵🇹', defaultLanguage: 'en' },
  { code: 'IE', name: 'Ireland',           nameNative: 'Éire',             currency: 'EUR', currencySymbol: '€',   languages: ['en', 'ar'],       flag: '🇮🇪', defaultLanguage: 'en' },
  { code: 'FI', name: 'Finland',           nameNative: 'Suomi',            currency: 'EUR', currencySymbol: '€',   languages: ['en', 'ar'],       flag: '🇫🇮', defaultLanguage: 'en' },
  { code: 'GR', name: 'Greece',            nameNative: 'Ελλάδα',           currency: 'EUR', currencySymbol: '€',   languages: ['en', 'tr', 'ar'], flag: '🇬🇷', defaultLanguage: 'en' },
  { code: 'CZ', name: 'Czech Republic',    nameNative: 'Česko',            currency: 'CZK', currencySymbol: 'Kč',  languages: ['en', 'ar'],       flag: '🇨🇿', defaultLanguage: 'en' },
  { code: 'LU', name: 'Luxembourg',        nameNative: 'Lëtzebuerg',       currency: 'EUR', currencySymbol: '€',   languages: ['en', 'fr', 'ar'], flag: '🇱🇺', defaultLanguage: 'en' },
  // Oceania & high-tech Asia-Pacific
  { code: 'AU', name: 'Australia',         nameNative: 'Australia',        currency: 'AUD', currencySymbol: 'A$',  languages: ['en', 'ar'],       flag: '🇦🇺', defaultLanguage: 'en' },
  { code: 'NZ', name: 'New Zealand',       nameNative: 'Aotearoa',         currency: 'NZD', currencySymbol: 'NZ$', languages: ['en', 'ar'],       flag: '🇳🇿', defaultLanguage: 'en' },
  { code: 'SG', name: 'Singapore',         nameNative: 'Singapore',        currency: 'SGD', currencySymbol: 'S$',  languages: ['en', 'ms', 'ar'], flag: '🇸🇬', defaultLanguage: 'en' },
  { code: 'JP', name: 'Japan',             nameNative: '日本',              currency: 'JPY', currencySymbol: '¥',   languages: ['en', 'ar'],       flag: '🇯🇵', defaultLanguage: 'en' },
  // Latin America — largest Muslim community + biggest LatAm tech scene
  { code: 'BR', name: 'Brazil',            nameNative: 'Brasil',           currency: 'BRL', currencySymbol: 'R$',  languages: ['en', 'ar'],       flag: '🇧🇷', defaultLanguage: 'en' }
];

export const languages = [
  { code: 'en', name: 'English', nameNative: 'English', dir: 'ltr' },
  { code: 'ar', name: 'Arabic', nameNative: 'العربية', dir: 'rtl' },
  { code: 'ur', name: 'Urdu', nameNative: 'اردو', dir: 'rtl' },
  { code: 'fr', name: 'French', nameNative: 'Français', dir: 'ltr' },
  { code: 'ms', name: 'Malay', nameNative: 'Bahasa Melayu', dir: 'ltr' },
  { code: 'tr', name: 'Turkish', nameNative: 'Türkçe', dir: 'ltr' },
  { code: 'ru', name: 'Russian', nameNative: 'Русский', dir: 'ltr' },
  // ---------- Feb 2026: 4 new languages (community-translated, English fallback for unmapped keys) ----------
  { code: 'hi', name: 'Hindi',      nameNative: 'हिन्दी',     dir: 'ltr', beta: true },
  { code: 'bn', name: 'Bengali',    nameNative: 'বাংলা',      dir: 'ltr', beta: true },
  { code: 'ml', name: 'Malayalam',  nameNative: 'മലയാളം',     dir: 'ltr', beta: true },
  { code: 'id', name: 'Indonesian', nameNative: 'Bahasa Indonesia', dir: 'ltr', beta: true },
  { code: 'fa', name: 'Persian',    nameNative: 'فارسی',          dir: 'rtl', beta: true },
  // ---------- Mar 2026: Dari, Swahili, Uzbek (community-translated, English fallback until Round-6 batch completes) ----------
  { code: 'prs', name: 'Dari',      nameNative: 'دری',              dir: 'rtl', beta: true },
  { code: 'sw',  name: 'Swahili',   nameNative: 'Kiswahili',        dir: 'ltr', beta: true },
  { code: 'uz',  name: 'Uzbek',     nameNative: 'Oʻzbekcha',        dir: 'ltr', beta: true }
];

// Person types with their specific asset fields
export const personTypes = [
  {
    id: 'salaried',
    icon: 'Briefcase',
    color: 'emerald',
    assetFields: ['cash', 'savings', 'gold', 'silver', 'mutualFunds', 'holdings', 'shares', 'providentFund'],
    deductionFields: ['debts', 'loans']
  },
  {
    id: 'selfEmployed',
    icon: 'User',
    color: 'blue',
    assetFields: ['cash', 'savings', 'gold', 'silver', 'mutualFunds', 'holdings', 'shares', 'receivables', 'businessCash'],
    deductionFields: ['debts', 'businessExpenses']
  },
  {
    id: 'businessOwner',
    icon: 'Store',
    color: 'purple',
    assetFields: ['cash', 'savings', 'gold', 'silver', 'inventory', 'receivables', 'businessBank', 'tradeGoods'],
    deductionFields: ['debts', 'payables', 'businessLiabilities']
  },
  {
    id: 'investor',
    icon: 'TrendingUp',
    color: 'green',
    assetFields: ['cash', 'savings', 'gold', 'silver', 'mutualFunds', 'holdings', 'shares', 'bonds', 'crypto', 'dividends'],
    deductionFields: ['debts', 'marginLoans']
  },
  {
    id: 'farmer',
    icon: 'Wheat',
    color: 'amber',
    assetFields: ['cash', 'savings', 'gold', 'silver', 'crops', 'livestock', 'farmEquipment', 'landForSale'],
    deductionFields: ['debts', 'farmingExpenses']
  },
  {
    id: 'retiree',
    icon: 'Clock',
    color: 'slate',
    assetFields: ['cash', 'savings', 'gold', 'silver', 'pension', 'gratuity', 'mutualFunds', 'holdings', 'shares'],
    deductionFields: ['debts', 'medicalExpenses']
  },
  {
    id: 'student',
    icon: 'GraduationCap',
    color: 'indigo',
    assetFields: ['cash', 'savings', 'gold', 'silver', 'scholarships'],
    deductionFields: ['debts', 'educationLoans']
  },
  {
    id: 'women',
    icon: 'Heart',
    color: 'pink',
    assetFields: ['cash', 'savings', 'goldJewellery', 'silverJewellery', 'mahr', 'mutualFunds', 'holdings', 'shares'],
    deductionFields: ['debts']
  },
  {
    id: 'landlord',
    icon: 'Home',
    color: 'orange',
    assetFields: ['cash', 'savings', 'gold', 'silver', 'rentalIncome', 'propertyForSale', 'advances'],
    deductionFields: ['debts', 'propertyLiabilities', 'maintenanceDues']
  },
  {
    id: 'crypto',
    icon: 'Bitcoin',
    color: 'yellow',
    assetFields: ['cash', 'savings', 'gold', 'silver', 'bitcoin', 'ethereum', 'altcoins', 'stablecoins', 'nfts'],
    deductionFields: ['debts']
  },
  {
    id: 'livestock',
    icon: 'Milk',
    color: 'lime',
    assetFields: ['cash', 'savings', 'gold', 'silver', 'camels', 'cattle', 'sheep', 'goats', 'poultry'],
    deductionFields: ['debts', 'feedExpenses']
  },
  {
    id: 'professional',
    icon: 'Award',
    color: 'cyan',
    assetFields: ['cash', 'savings', 'gold', 'silver', 'mutualFunds', 'holdings', 'shares', 'receivables', 'practiceAssets'],
    deductionFields: ['debts', 'practiceExpenses']
  }
];

// Asset field definitions
export const assetFields = {
  // Cash & Savings
  cash: { label: 'Cash in Hand', type: 'currency', category: 'cash', tooltip: 'All physical cash at home or in your wallet. Include any currency you have on hand.' },
  savings: { label: 'Bank Savings', type: 'currency', category: 'cash', tooltip: 'Total balance in all savings, current, and fixed-deposit accounts (if accessible).' },
  businessCash: { label: 'Business Cash', type: 'currency', category: 'cash', tooltip: 'Cash held in business premises or petty-cash boxes.' },
  businessBank: { label: 'Business Bank Account', type: 'currency', category: 'cash', tooltip: 'Total balance in all business bank accounts.' },
  
  // Gold & Silver
  gold: { label: 'Gold (grams)', type: 'weight', category: 'metals', metalType: 'gold', tooltip: 'Total weight of all gold you own (bars, coins, ornaments). Enter in grams of 24K equivalent.' },
  silver: { label: 'Silver (grams)', type: 'weight', category: 'metals', metalType: 'silver', tooltip: 'Total weight of all silver you own (bars, coins, utensils). Enter in grams of 999 purity.' },
  goldJewellery: { label: 'Gold Jewellery (grams)', type: 'weight', category: 'metals', metalType: 'gold', tooltip: 'Weight of gold jewellery. Hanafi: always zakatable. Other schools: worn jewellery may be exempt. Enter 24K equivalent weight.' },
  silverJewellery: { label: 'Silver Jewellery (grams)', type: 'weight', category: 'metals', metalType: 'silver', tooltip: 'Weight of silver jewellery. Similar rules as gold jewellery — check your madhhab position.' },
  
  // Investments
  investments: { label: 'General Investments', type: 'currency', category: 'investments' },
  stocks: { label: 'Stocks (Market Value)', type: 'currency', category: 'investments', smartQuestion: 'stocks' },
  mutualFunds: { label: 'Mutual Funds (Current Value)', type: 'currency', category: 'investments', tooltip: 'Include the current NAV of all mutual fund units you hold for at least one lunar year.' },
  holdings: { label: 'Holdings / Direct Equity', type: 'currency', category: 'investments', smartQuestion: 'stocks', tooltip: 'Equity stakes in companies you hold directly, not through listed exchanges.' },
  shares: { label: 'Shares (Unlisted / Private Co.)', type: 'currency', category: 'investments', smartQuestion: 'stocks', tooltip: 'Shares in private or unlisted companies. Valuation can be book value or agreed fair value.' },
  bonds: { label: 'Bonds', type: 'currency', category: 'investments', tooltip: 'Sukuk or conventional bonds. Include face value plus accrued profit/interest.' },
  dividends: { label: 'Pending Dividends', type: 'currency', category: 'investments', tooltip: 'Declared but uncollected dividends from your investments.' },
  providentFund: { label: 'Provident Fund (Accessible)', type: 'currency', category: 'investments', tooltip: 'Only the portion you can access/withdraw. Locked employer contributions may be exempt.' },
  
  // Crypto
  crypto: { label: 'Cryptocurrency (Total)', type: 'currency', category: 'crypto', smartQuestion: 'crypto' },
  bitcoin: { label: 'Bitcoin (Value)', type: 'currency', category: 'crypto', smartQuestion: 'crypto', tooltip: 'Current market value of your Bitcoin holdings.' },
  ethereum: { label: 'Ethereum (Value)', type: 'currency', category: 'crypto', smartQuestion: 'crypto', tooltip: 'Current market value of your Ethereum holdings.' },
  altcoins: { label: 'Other Altcoins', type: 'currency', category: 'crypto', smartQuestion: 'crypto', tooltip: 'Total value of all other cryptocurrencies you hold.' },
  stablecoins: { label: 'Stablecoins', type: 'currency', category: 'crypto', tooltip: 'USDT, USDC, etc. Treated like cash equivalents for Zakat purposes.' },
  nfts: { label: 'NFTs (Tradeable Value)', type: 'currency', category: 'crypto', tooltip: 'Only NFTs held for resale/trading. Personal-use digital collectibles may be exempt.' },
  
  // Business
  inventory: { label: 'Inventory / Stock for Sale', type: 'currency', category: 'business', tooltip: 'Goods purchased or manufactured for resale. Value at current market/sale price, not cost.' },
  receivables: { label: 'Accounts Receivable', type: 'currency', category: 'business', tooltip: 'Money owed to you by customers/clients that you expect to collect.' },
  tradeGoods: { label: 'Trade Goods', type: 'currency', category: 'business', tooltip: 'Commodities or raw materials held for trading, not for personal use or fixed assets.' },
  practiceAssets: { label: 'Practice Assets', type: 'currency', category: 'business', tooltip: 'Liquid assets of your professional practice (law, medical, consultancy), excluding fixed tools/equipment.' },
  
  // Real Estate
  rentalIncome: { label: 'Rental Income (Saved)', type: 'currency', category: 'realestate', tooltip: 'Accumulated rental income you have saved. Zakat is on the saved rent, not the property itself (unless it is for sale).' },
  propertyForSale: { label: 'Property for Sale', type: 'currency', category: 'realestate', tooltip: 'Market value of property you intend to sell. Property for personal use is NOT zakatable.' },
  advances: { label: 'Advances Received', type: 'currency', category: 'realestate', tooltip: 'Security deposits or advance rent received that you hold.' },
  
  // Agriculture
  crops: { label: 'Crops Value', type: 'currency', category: 'agriculture', tooltip: 'Value of harvested crops. Zakat on rain-fed crops is 10%; irrigated crops is 5% (Ushr). This calculator applies the standard 2.5% — adjust manually if Ushr applies.' },
  livestock: { label: 'Livestock Value', type: 'currency', category: 'agriculture', tooltip: 'Total market value of livestock not covered by specific nisab counts below. Includes poultry, fish farms, etc.' },
  farmEquipment: { label: 'Equipment for Sale', type: 'currency', category: 'agriculture', tooltip: 'Only equipment you intend to sell. Tools used for farming are personal-use assets and are exempt.' },
  landForSale: { label: 'Land for Sale', type: 'currency', category: 'agriculture', tooltip: 'Market value of agricultural land held for sale. Land used for farming is exempt.' },
  
  // Livestock specific
  camels: { label: 'Camels (Head Count)', type: 'count', category: 'livestock', smartQuestion: 'livestock', tooltip: 'Nisab: 5 camels. Zakat: 5-9 → 1 sheep; 10-14 → 2 sheep; 15-19 → 3 sheep; 20-24 → 4 sheep; 25-35 → 1 young she-camel (bint makhad); 36-45 → 1 two-year she-camel (bint labun). Enter total head count.' },
  cattle: { label: 'Cattle / Cows (Head Count)', type: 'count', category: 'livestock', smartQuestion: 'livestock', tooltip: 'Nisab: 30 cattle. Zakat: 30-39 → 1 one-year calf (tabi); 40-59 → 1 two-year cow (musinnah); 60-69 → 2 tabi; 70-79 → 1 tabi + 1 musinnah. Enter total head count.' },
  sheep: { label: 'Sheep (Head Count)', type: 'count', category: 'livestock', smartQuestion: 'livestock', tooltip: 'Nisab: 40 sheep/goats. Zakat: 40-120 → 1 sheep; 121-200 → 2 sheep; 201-399 → 3 sheep; then 1 additional sheep per 100. Enter total head count.' },
  goats: { label: 'Goats (Head Count)', type: 'count', category: 'livestock', smartQuestion: 'livestock', tooltip: 'Same nisab rules as sheep. 40-120 → 1 goat; 121-200 → 2; 201-399 → 3; then +1 per 100 additional. Free-grazing animals only — stall-fed commercial livestock is treated as trade goods.' },
  poultry: { label: 'Poultry (Market Value)', type: 'currency', category: 'livestock', smartQuestion: 'livestock', tooltip: 'Commercial poultry is treated as trade goods — enter total market value. Poultry kept for personal eggs/meat is exempt.' },
  
  // Retirement
  pension: { label: 'Pension (Accessible)', type: 'currency', category: 'retirement', tooltip: 'Only the portion you can currently access or withdraw. Locked employer contributions are typically exempt until you receive them.' },
  gratuity: { label: 'Gratuity', type: 'currency', category: 'retirement', tooltip: 'End-of-service gratuity if it is receivable now. If still locked with employer, it may be exempt — consult your scholar.' },
  
  // Women specific
  mahr: { label: 'Mahr (Receivable)', type: 'currency', category: 'personal', tooltip: 'Deferred mahr (dowry) owed to you. Hanafi: zakatable if you expect to receive it. Other schools vary.' },
  
  // Student
  scholarships: { label: 'Scholarship Balance', type: 'currency', category: 'personal', tooltip: 'Scholarship money you have saved (not yet spent on education). If restricted to education use, it may be exempt.' }
};

// Deduction field definitions
export const deductionFields = {
  debts: { label: 'Personal Debts', type: 'currency', tooltip: 'Outstanding personal debts due within the next 12 months (credit cards, personal loans, etc.).' },
  loans: { label: 'Loans to Repay', type: 'currency', tooltip: 'Loan instalments due in the coming year. Only include the current year\'s portion, not the total loan.' },
  businessExpenses: { label: 'Business Expenses Due', type: 'currency', tooltip: 'Business-related expenses and bills due for payment (supplier invoices, rent, salaries).' },
  payables: { label: 'Payables to Suppliers', type: 'currency', tooltip: 'Money owed to suppliers for goods or services already received.' },
  businessLiabilities: { label: 'Business Liabilities', type: 'currency', tooltip: 'Other business liabilities: tax due, pending refunds owed to customers, etc.' },
  marginLoans: { label: 'Margin Loans', type: 'currency', tooltip: 'Outstanding margin loans from your broker used for stock purchases.' },
  farmingExpenses: { label: 'Farming Expenses Due', type: 'currency', tooltip: 'Pending farming costs: seeds, fertiliser, labour, equipment hire.' },
  medicalExpenses: { label: 'Medical Expenses Due', type: 'currency', tooltip: 'Outstanding medical bills and treatment costs due for payment.' },
  educationLoans: { label: 'Education Loans', type: 'currency', tooltip: 'Education loan instalments due in the coming year.' },
  propertyLiabilities: { label: 'Property Liabilities', type: 'currency', tooltip: 'Mortgage instalments, property tax, or maintenance charges due.' },
  maintenanceDues: { label: 'Maintenance Dues', type: 'currency', tooltip: 'Pending maintenance or service charges for rental properties.' },
  feedExpenses: { label: 'Feed/Care Expenses Due', type: 'currency', tooltip: 'Pending costs for animal feed, veterinary care, and livestock maintenance.' },
  practiceExpenses: { label: 'Practice Expenses Due', type: 'currency', tooltip: 'Professional practice costs: office rent, staff salaries, subscriptions due.' }
};

// Nisab constants
export const nisabConstants = {
  goldGrams: 85, // Updated to commonly used 85g
  silverGrams: 595,
  zakatRate: 0.025 // 2.5%
};

// Islamic schools of thought rulings
export const scholarlyRulings = {
  hanafi: {
    name: 'Hanafi',
    jewellery: 'Zakat is due on gold/silver jewellery if it reaches nisab, even if worn regularly.',
    pension: 'Zakat is due on accessible pension funds. Locked funds are exempt until withdrawal.',
    crypto: 'Treated as trade goods (urood al-tijara). Zakat due on market value.',
    stocks: 'Zakat on market value if held for trading. Only on dividends if held for returns.',
    business: 'Zakat on trade goods at market value. Fixed assets are exempt.'
  },
  maliki: {
    name: 'Maliki',
    jewellery: 'Jewellery worn regularly is exempt. Zakat only on stored/unused gold/silver.',
    pension: 'Similar to Hanafi. Accessible funds are zakatable.',
    crypto: 'Treated as currency or trade goods based on usage.',
    stocks: 'Zakat on market value or underlying assets (zakatable portion).',
    business: 'Similar to Hanafi regarding trade goods.'
  },
  shafii: {
    name: "Shafi'i",
    jewellery: 'Permissible jewellery worn by women is exempt from zakat.',
    pension: 'Zakat due when fund becomes accessible.',
    crypto: 'Contemporary scholars apply trade goods rules.',
    stocks: 'Zakat on market value for trading stocks.',
    business: 'Zakat on goods intended for sale.'
  },
  hanbali: {
    name: 'Hanbali',
    jewellery: 'Similar to Shafi\'i - permissible jewellery is exempt.',
    pension: 'Zakat on accessible funds.',
    crypto: 'Considered tradeable assets.',
    stocks: 'Market value approach for zakatable stocks.',
    business: 'Trade goods valued at current market price.'
  },
  aaoifi: {
    name: 'AAOIFI Standard',
    jewellery: 'Recommends following local scholarly opinion.',
    pension: 'Detailed framework for different fund types.',
    crypto: 'Digital assets treated as tradeable goods.',
    stocks: 'Clear guidelines on market value vs underlying assets.',
    business: 'Comprehensive business zakat framework.'
  },
  jafari: {
    name: "Ja'fari (Shia)",
    jewellery: 'Personal jewellery is exempt; hoarded gold/silver reaches nisab (Khums applies separately on annual savings).',
    pension: 'Accessible funds count toward the year-end surplus for Khums; classical Zakat is restricted to nine specific items.',
    crypto: 'Contemporary Ja\'fari jurists treat crypto as commercial gain — Khums (1/5) is due on the net annual profit after expenses.',
    stocks: 'Trading gains fall under Khums on annual surplus; long-hold shares similar treatment.',
    business: 'Business profits after annual expenses are subject to Khums (1/5), distinct from the Sunni 2.5% Zakat rate.'
  }
};

export const getCountryByCode = (code) => countries.find(c => c.code === code);
export const getLanguageByCode = (code) => languages.find(l => l.code === code);
export const getPersonTypeById = (id) => personTypes.find(p => p.id === id);

// Smart question definitions for nuanced asset types
export const smartQuestions = {
  stocks: {
    question: 'Are these held mainly to trade (buy/sell for profit)?',
    options: [
      { value: 'trading', label: 'Yes, actively trading', guidance: 'Zakat is due on the full market value at 2.5%.', detail: 'Trading stocks are treated like trade goods (urood al-tijara). The entire current market value is zakatable.' },
      { value: 'investment', label: 'No, held for long-term / dividends', guidance: 'Zakat applies to the zakatable portion (cash + receivables of the company) or on dividends received.', detail: 'For investment stocks, many scholars say zakat is on the underlying zakatable assets (cash, receivables) proportional to your ownership. Others say only on dividends you receive.' }
    ],
    expertNote: 'In expert mode: Trading stocks → 2.5% of market value. Investment stocks → 2.5% of (cash + receivables ÷ total shares × your shares), or simply on dividends saved for a year. Consult your scholar for mixed portfolios.'
  },
  crypto: {
    question: 'How do you primarily use your crypto assets?',
    options: [
      { value: 'trading', label: 'Actively trading for profit', guidance: 'Zakat is due on the full market value at 2.5%, like trade goods.', detail: 'Actively traded crypto is classified as trade goods. Calculate zakat on the total market value on your zakat date.' },
      { value: 'holding', label: 'Long-term holding (HODL)', guidance: 'Zakat is still due on the market value, as most scholars treat crypto as a zakatable asset.', detail: 'Even for long-term holdings, the majority scholarly position is that zakat applies to the current market value, since crypto is a store of value similar to gold/currency.' }
    ],
    expertNote: 'Both trading and holding crypto are generally zakatable at 2.5% of market value. The distinction matters for record-keeping: traders should use their zakat anniversary date valuation. Some Hanafi scholars may exempt personal-use tokens — confirm with your scholar.'
  },
  livestock: {
    question: 'How are your animals kept?',
    options: [
      { value: 'grazing', label: 'Free-grazing (sa\'imah)', guidance: 'Specific nisab counts apply: 5 camels, 30 cattle, or 40 sheep/goats. See each field for exact zakat amounts per head count.', detail: 'Free-grazing (sa\'imah) livestock have specific zakat nisab and rates based on head count, not market value. The animal must graze freely for most of the year. Enter head counts in each field below.' },
      { value: 'commercial', label: 'Stall-fed / commercial farm', guidance: 'Treated as trade goods — enter total market value. Zakat is 2.5% of market value.', detail: 'Commercially raised, stall-fed animals are classified as trade goods (urood al-tijara). Zakat is 2.5% on total market value, not by head count. This includes poultry farms, fish farms, and dairy operations.' }
    ],
    expertNote: 'Key distinction: Free-grazing (sa\'imah) animals have nisab thresholds by count (e.g., 5 camels, 30 cattle, 40 sheep). Commercial/stall-fed animals follow the standard 2.5% on market value. Mixed herds: separate free-grazing from stall-fed and apply each rule independently. Calves/lambs are counted with adults for nisab purposes.'
  }
};

